import React, { Component } from 'react'
import { StyleSheet, css } from '../../utility/paypalAphrodite';
import fonts from '../../styles/fonts';
import colors from '../../styles/colors';
import PropTypes from 'prop-types';
import { CURRENCY_CONVERSION_OPTIONS } from '../../pages/guest/crossBorder';
import { localsMessages } from '../../utility/getTemplateData';
import SuccessCheckmark from '../successCheckmark/SuccessCheckmark';
const messages = localsMessages('guest/crossBorder');

const styles = StyleSheet.create({
	modal: {
		background: '#f4f6f9',
		height: '100%'
	},
	modalDialog: {
		background: 'white',
		height: '100%',
		marginTop: 0,
		marginBottom: 0,
		width: 696,
		'@media (max-width: 767px)': {
			width: '100%'
		}
	},
	// Currency Conversion
	modalTitle: {
		marginTop: 0,
		fontSize: 30,
		fontFamily: fonts.ppSansBigLight,
		fontWeight: 300,
		marginBottom: 14
	},
	optionTitle: {
		color: colors.linkBlue,
		fontFamily: fonts.ppSansSmallMedium,
		fontSize: '15px',
		fontWeight: 500,
		lineHeight: 1.33,
		textAlign: 'center'
	},
	currencyConversionOption: {
		padding: '40px 48px 25px 40px',
		position: 'relative',
		maxWidth: 390,
		margin: '0 auto',
		cursor: 'pointer',
		border: 'solid 1px #d0d6da',
		borderRadius: 6
	},
	optionSelected: {
		border: '1px solid #00cf92',
	},
	optionsContainer: {
		paddingTop: 0
	},
	optionIcon: {
		width: '70px',
		height: '100%',
		display: 'block',
		margin: '0 auto'
	},
	optionDetails: {
		textAlign: 'center'
	},
	bodyText: {
		fontSize: '15px',
		color: '#2c2e2f',
		margin: 0,
		fontFamily: fonts.ppSansSmallRegular
	},
	boldText: {
		fontWeight: 500,
		fontFamily: fonts.ppSansSmallMedium
	},
	icon: {
		height: 34,
		width: 34
	},
	highlightedOption: {
		position: 'absolute',
		left: '-26px',
		top: '37%',
		height: '45px',
		background: 'white'
	},
	closeBtn: {
		fontSize: 32,
		color: '#444444'
	},
	iconCustom: {
		':before': {
			fontSize: '4rem'
		},
		color: '#00c99c'
	}
});

const SuccessCheckmarkIcon = (props) => {
	return (
		<div className={css(styles.highlightedOption)} >
			<SuccessCheckmark />
		</div>
	)
};

const CurrencyConversionOption = (props) => {
	return (
		<div>
			<div
				className={`currency-conversion-option ${css(styles.currencyConversionOption)} ${ props.isSelected ? `${css(styles.optionSelected)}` : '' }`}
				onClick={() => props.handleOptionSelection(props.type)}
			>
				{props.isSelected && <SuccessCheckmarkIcon />}

				<div className={css(styles.optionIcon)}>
					<span className={`icon ${props.icon} ${css(styles.iconCustom)}`} aria-hidden="true" />
				</div>
				<div className={css(styles.optionsContainer)}>
					<h2 className={`${css(styles.optionTitle)}`}>{props.title}</h2>
					<div className={`${css(styles.optionDetails)}`}>
						{props.rate && <p className={`${css(styles.bodyText)} ${css(styles.boldText)}`}>{} {props.rate}</p>}
						<p className={`${css(styles.bodyText)}`}>{props.description}</p>
					</div>
				</div>
			</div>
			<div style={{ height: '25px' }} ></div>
		</div>
	)
};

CurrencyConversionOption.propTypes = {
	isSelected: PropTypes.bool,
	type: PropTypes.string,
	icon: PropTypes.string,
	title: PropTypes.string,
	rate: PropTypes.string,
	description: PropTypes.string
};

class CurrencyConversionModal extends Component {
	handleOptionSelection = (option) => {
		this.props.handleOptionSelection(option);
	}

	renderCloseButton() {
		return (
			<div className="modal-header text-right">
				<a href="#"
					className={`${css(styles.closeBtn)} icon icon-close-small`}
					onClick={this.props.hideModal}>
				</a>
			</div>
		)
	}

	render() {
		const { label } = messages;
		const { selectedOption, exchangeRate } = this.props;
		const isPayPalSelected = selectedOption === CURRENCY_CONVERSION_OPTIONS.PAYPAL;

		return (
			<div className={`currency-conversion modal donate_dialog fade ${css(styles.modal)}`} data-tabindex="-1" data-role="dialog" id="currencyConversion"
				data-backdrop="static">
				<div className={`modal-dialog ${css(styles.modalDialog)}`}>
					<div className="modal-content">
						{this.renderCloseButton()}
						<div style={{ height: '70px' }}></div>

						<div className="modal-body">
							<h2 className={`${css(styles.modalTitle)} } text-center`}>{label.modalTitle}</h2>
							<p className={`${css(styles.bodyText)} text-center `}>{label.modalSubTitle}</p>
							<div style={{ height: '40px' }}></div>
							
							<div>
								<CurrencyConversionOption
									isSelected={isPayPalSelected}
									icon={'icon-pp-logo-outline'}
									type={CURRENCY_CONVERSION_OPTIONS.PAYPAL}
									title={label.withPaypal.title}
									rate={`${label.withPayPal.rate}: ${exchangeRate}`}
									description={label.withPayPal.message}
									handleOptionSelection={this.handleOptionSelection}
								/>
								<CurrencyConversionOption
									isSelected={!isPayPalSelected}
									icon={'icon-credit-card'}
									type={CURRENCY_CONVERSION_OPTIONS.ISSUER}
									title={label.withCard.title}
									description={label.withCard.message}
									handleOptionSelection={this.handleOptionSelection}
								/>
							</div>
							
						</div>
					</div>
				</div>
			</div>
		)
	}
}

CurrencyConversionModal.propTypes = {
	handleOptionSelection: PropTypes.func.isRequired,
	hideModal: PropTypes.func,
	selectedOption: PropTypes.string,
	exchangeRate: PropTypes.string
}

export default CurrencyConversionModal;



// WEBPACK FOOTER //
// ./components/currencyConversion/CurrencyConversionModal.js